export default __webpack_public_path__ + "static/media/ally_background_m1.4013614e.jpg";